// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TicketTypeItem__wrapper___1XRRF","label":"TicketTypeItem__label___2ZYoq","active":"TicketTypeItem__active___3zlKQ"};